module.exports = __webpack_public_path__ + "static/logo-schatten-60ce945b6c4604dc8a0d66ae528310bb.png";